import { useEffect, useState } from "react";
import axios from "axios";
import { AdminLayout } from "../components/AdminLayout";
import { getAuthHeader } from "../context/AuthContext";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@/components/ui/tabs";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Loader2, Store } from "lucide-react";
import { toast } from "sonner";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

import { Truck } from "lucide-react";
const BACKEND_URL = window.location.origin;
const API = `${BACKEND_URL}/api`;

export default function OrderTypesManagementPage() {
  const [restaurant, setRestaurant] = useState(null);
  const [loading, setLoading] = useState(true);
  const [savingKey, setSavingKey] = useState("");
const [savingDeliveryProvider, setSavingDeliveryProvider] = useState(false);
  const orderTypeList = [
    { key: "dine_in", label: "Dine-In" },
    { key: "takeaway", label: "Takeaway" },
    { key: "online", label: "Online" },
    { key: "reservation", label: "Reservation" },
  ];
  const paymentTypeList = [
  { key: "cash", label: "Cash" },
  // { key: "card", label: "Card" },
  { key: "upi", label: "Online" },
  { key: "split", label: "Split Payment" },
];
const [restaurantForm, setRestaurantForm] = useState({
  subdomain: "",
  owner_name: "",
  owner_email: "",
  owner_phone: "",
  address: "",
});

const [savingRestaurantDetails, setSavingRestaurantDetails] = useState(false);

const [stripeForm, setStripeForm] = useState({
  publishable_key: "",
  secret_key: "",
  webhook_secret: "",
});
const [passwordForm, setPasswordForm] = useState({
  new_password: "",
  confirm_password: "",
});

const [savingPassword, setSavingPassword] = useState(false);
const [savingStripe, setSavingStripe] = useState(false);
const [showPasswordForm, setShowPasswordForm] = useState(false);
  useEffect(() => {
    fetchRestaurant();
  }, []);

  const fetchRestaurant = async () => {
    try {
      setLoading(true);

      const response = await axios.get(`${API}/restaurants`, {
        headers: getAuthHeader(),
      });

      // if array response
      const data = Array.isArray(response.data)
        ? response.data[0]
        : response.data;

      setRestaurant(data);
      setRestaurantForm({
  subdomain: data.subdomain || "",
  owner_name: data.owner_name || "",
  owner_email: data.owner_email || "",
  owner_phone: data.owner_phone || "",
  address: data.address || "",
});

setStripeForm({
  publishable_key:
    data?.stripe_config?.publishable_key || "",
  secret_key:
    data?.stripe_config?.secret_key || "",
  webhook_secret:
    data?.stripe_config?.webhook_secret || "",
});
    } catch (error) {
      console.error(error);
      toast.error("Failed to load restaurant settings");
    } finally {
      setLoading(false);
    }
  };
const updateRestaurantDetails = async () => {
  try {
    setSavingRestaurantDetails(true);

    await axios.put(
      `${API}/restaurants/details`,
      restaurantForm,
      {
        headers: getAuthHeader(),
      }
    );

    toast.success("Restaurant details updated");

    fetchRestaurant();

  } catch (error) {
    console.error(error);

    toast.error("Failed to update restaurant details");

  } finally {
    setSavingRestaurantDetails(false);
  }
};
const resetRestaurantPassword = async () => {
  try {
    if (!passwordForm.new_password) {
      toast.error("Password is required");
      return;
    }

    if (passwordForm.new_password.length < 8) {
      toast.error("Password must be at least 8 characters");
      return;
    }

    if (
      passwordForm.new_password !==
      passwordForm.confirm_password
    ) {
      toast.error("Passwords do not match");
      return;
    }

    setSavingPassword(true);

    await axios.post(
      `${API}/restaurants/${restaurant.id}/reset-password`,
      {
        new_password: passwordForm.new_password,
      },
      {
        headers: getAuthHeader(),
      }
    );

    toast.success("Password reset successfully");

    setPasswordForm({
      new_password: "",
      confirm_password: "",
    });
  } catch (error) {
    console.error(error);

    toast.error(
      error?.response?.data?.detail ||
        "Failed to reset password"
    );
  } finally {
    setSavingPassword(false);
  }
};
const updateStripeConfiguration = async () => {
  try {

    setSavingStripe(true);

    await axios.put(
      `${API}/restaurants/stripe-config`,
      stripeForm,
      {
        headers: getAuthHeader(),
      }
    );

    toast.success("Stripe configuration updated");

    fetchRestaurant();

  } catch (error) {

    console.error(error);

    toast.error("Failed to update stripe configuration");

  } finally {

    setSavingStripe(false);
  }
};
  const updateOrderType = async (type, enabled) => {
    try {
      setSavingKey(type);

      // optimistic UI
      setRestaurant((prev) => ({
        ...prev,
        order_types: {
          ...prev.order_types,
          [type]: enabled,
        },
      }));

      await axios.put(
        `${API}/restaurants/order-types`,
        {
          type,
          enabled,
        },
        {
          headers: getAuthHeader(),
        }
      );

      toast.success("Updated successfully");
    } catch (error) {
      console.error(error);
      toast.error("Failed to update");

      fetchRestaurant();
    } finally {
      setSavingKey("");
    }
  };
  const updatePaymentType = async (type, enabled) => {
  try {
    setSavingKey(`payment_${type}`);

    // optimistic UI
    setRestaurant((prev) => ({
      ...prev,
      payment_types: {
        ...prev.payment_types,
        [type]: enabled,
      },
    }));

    await axios.put(
      `${API}/restaurants/payment-types`,
      {
        type,
        enabled,
      },
      {
        headers: getAuthHeader(),
      }
    );

    toast.success("Payment updated successfully");
  } catch (error) {
    console.error(error);
    toast.error("Failed to update payment");

    fetchRestaurant();
  } finally {
    setSavingKey("");
  }
};
const updateDeliveryProvider = async (provider) => {
  try {

    setSavingDeliveryProvider(true);

    // optimistic update
    setRestaurant((prev) => ({
      ...prev,
      delivery_provider: provider,
    }));

    await axios.put(
      `${API}/restaurants/delivery-provider`,
      {
        delivery_provider: provider,
      },
      {
        headers: getAuthHeader(),
      }
    );

    toast.success("Delivery provider updated");

  } catch (error) {

    console.error(error);

    toast.error("Failed to update delivery provider");

    fetchRestaurant();

  } finally {

    setSavingDeliveryProvider(false);
  }
};
 return (
  <AdminLayout>
    <div className="min-h-screen bg-slate-100">
      
      {/* Header */}
      <div className="bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-8 py-7">

          <div className="flex items-center justify-between flex-wrap gap-5">

            <div>
              <h1 className="text-3xl font-bold text-slate-800">
                Restaurant Settings
              </h1>

              <p className="text-slate-500 mt-2">
                Configure ordering, payments and delivery preferences
              </p>
            </div>

            <div className="bg-slate-100 px-5 py-4 rounded-2xl border border-slate-200">
              <div className="flex items-center gap-3">

                <div className="bg-blue-100 p-3 rounded-xl">
                  <Store className="text-blue-600" size={22} />
                </div>

                <div>
                  <p className="font-semibold text-slate-800">
                    {restaurant?.name || "Restaurant"}
                  </p>

                  <p className="text-sm text-slate-500">
                    POS Configuration Panel
                  </p>
                </div>

              </div>
            </div>

          </div>

        </div>
      </div>

      <div className="max-w-7xl mx-auto p-8">

        {loading ? (
          <div className="bg-white rounded-3xl shadow-sm p-10 flex items-center gap-3">
            <Loader2 className="animate-spin" size={20} />
            Loading settings...
          </div>
        ) : (
          
        <Tabs
          defaultValue="general"
          className="space-y-6"
        >
          <TabsList className="grid w-full grid-cols-4">
            <TabsTrigger value="general">
              General
            </TabsTrigger>

            <TabsTrigger value="ordering">
              Ordering
            </TabsTrigger>

            <TabsTrigger value="payments">
              Payments
            </TabsTrigger>

            <TabsTrigger value="delivery">
              Delivery
            </TabsTrigger>
          </TabsList>

          {/* GENERAL */}
          <TabsContent value="general">
              {/* RESTAURANT DETAILS */}
              <div className="bg-white rounded-3xl shadow-sm border border-slate-200 overflow-hidden">

                <div className="border-b border-slate-100 px-7 py-5">
                  <h2 className="text-2xl font-bold text-slate-800">
                    Restaurant Details
                  </h2>

                  <p className="text-slate-500 mt-1">
                    Update owner and restaurant contact information
                  </p>
                </div>

                <div className="p-7">

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-5">

                    <div>
                      <Label className="mb-2 block">Restaurant Name</Label>

                      <input
                        value={restaurant?.name || ""}
                        disabled
                        className="w-full border rounded-xl px-4 py-3 bg-slate-100"
                      />
                    </div>

                    <div>
                      <Label className="mb-2 block">Subdomain</Label>

                      <input
                        value={restaurantForm.subdomain}
                        onChange={(e) =>
                          setRestaurantForm({
                            ...restaurantForm,
                            subdomain: e.target.value,
                          })
                        }
                        className="w-full border rounded-xl px-4 py-3"
                      />
                    </div>

                    <div>
                      <Label className="mb-2 block">Owner Name</Label>

                      <input
                        value={restaurantForm.owner_name}
                        onChange={(e) =>
                          setRestaurantForm({
                            ...restaurantForm,
                            owner_name: e.target.value,
                          })
                        }
                        className="w-full border rounded-xl px-4 py-3"
                      />
                    </div>

                    <div>
                      <Label className="mb-2 block">Owner Email</Label>

                      <input
                        value={restaurantForm.owner_email}
                        onChange={(e) =>
                          setRestaurantForm({
                            ...restaurantForm,
                            owner_email: e.target.value,
                          })
                        }
                        className="w-full border rounded-xl px-4 py-3"
                      />
                    </div>

                    <div>
                      <Label className="mb-2 block">Owner Phone</Label>

                      <input
                        value={restaurantForm.owner_phone}
                        onChange={(e) =>
                          setRestaurantForm({
                            ...restaurantForm,
                            owner_phone: e.target.value,
                          })
                        }
                        className="w-full border rounded-xl px-4 py-3"
                      />
                    </div>

                    <div className="md:col-span-2">
                      <Label className="mb-2 block">Address</Label>

                      <textarea
                        rows={3}
                        value={restaurantForm.address}
                        onChange={(e) =>
                          setRestaurantForm({
                            ...restaurantForm,
                            address: e.target.value,
                          })
                        }
                        className="w-full border rounded-xl px-4 py-3"
                      />
                    </div>

                  </div>

                  <button
                    onClick={updateRestaurantDetails}
                    disabled={savingRestaurantDetails}
                    className="mt-6 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-xl font-semibold"
                  >
                    {savingRestaurantDetails
                      ? "Saving..."
                      : "Save Restaurant Details"}
                  </button>

                </div>

              </div>
              {/* PASSWORD RESET */}
              <div className="bg-white rounded-3xl shadow-sm border border-slate-200 overflow-hidden">

                <div className="border-b border-slate-100 px-7 py-5">
                  <h2 className="text-2xl font-bold text-slate-800">
                    Admin Password
                  </h2>

                  <p className="text-slate-500 mt-1">
                    Manage restaurant admin login password
                  </p>
                </div>

                <div className="p-7">

                  {!showPasswordForm ? (

                    <button
                      onClick={() => setShowPasswordForm(true)}
                      className="bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-xl font-semibold"
                    >
                      Change Password
                    </button>

                  ) : (

                    <>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">

                        <div>
                          <Label className="mb-2 block">
                            New Password
                          </Label>

                          <input
                            type="password"
                            value={passwordForm.new_password}
                            onChange={(e) =>
                              setPasswordForm({
                                ...passwordForm,
                                new_password: e.target.value,
                              })
                            }
                            placeholder="Minimum 8 characters"
                            className="w-full border rounded-xl px-4 py-3"
                          />
                        </div>

                        <div>
                          <Label className="mb-2 block">
                            Confirm Password
                          </Label>

                          <input
                            type="password"
                            value={passwordForm.confirm_password}
                            onChange={(e) =>
                              setPasswordForm({
                                ...passwordForm,
                                confirm_password: e.target.value,
                              })
                            }
                            placeholder="Re-enter password"
                            className="w-full border rounded-xl px-4 py-3"
                          />
                        </div>

                      </div>

                      <div className="flex gap-3 mt-6">

                        <button
                          onClick={resetRestaurantPassword}
                          disabled={savingPassword}
                          className="bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-xl font-semibold flex items-center gap-2"
                        >
                          {savingPassword && (
                            <Loader2
                              size={18}
                              className="animate-spin"
                            />
                          )}

                          {savingPassword
                            ? "Updating..."
                            : "Update Password"}
                        </button>

                        <button
                          onClick={() => {
                            setShowPasswordForm(false);

                            setPasswordForm({
                              new_password: "",
                              confirm_password: "",
                            });
                          }}
                          className="border border-slate-300 hover:bg-slate-50 px-6 py-3 rounded-xl font-semibold"
                        >
                          Cancel
                        </button>

                      </div>
                    </>

                  )}

                </div>

              </div>
          </TabsContent>

          {/* ORDERING */}
          <TabsContent value="ordering">
              {/* ORDER TYPES */}
              <div className="bg-white rounded-3xl shadow-sm border border-slate-200 overflow-hidden">

                <div className="border-b border-slate-100 px-7 py-5">
                  <h2 className="text-2xl font-bold text-slate-800">
                    Order Channels
                  </h2>

                  <p className="text-slate-500 mt-1">
                    Enable ordering methods available to customers
                  </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5 p-7">

                  {orderTypeList.map((item) => {

                    const checked =
                      restaurant?.order_types?.[item.key] ?? true;

                    const saving = savingKey === item.key;

                    return (
                      <div
                        key={item.key}
                        className={`
                          border rounded-2xl p-5 transition-all
                          ${
                            checked
                              ? "border-green-200 bg-green-50"
                              : "border-slate-200 bg-slate-50"
                          }
                        `}
                      >

                        <div className="flex items-start justify-between">

                          <div>
                            <p className="font-semibold text-slate-800 text-lg">
                              {item.label}
                            </p>

                            <p className="text-sm mt-1 text-slate-500">
                              {checked ? "Active" : "Disabled"}
                            </p>
                          </div>

                          <div className="flex items-center gap-2">

                            {saving && (
                              <Loader2
                                size={16}
                                className="animate-spin text-slate-500"
                              />
                            )}

                            <Switch
                              checked={checked}
                              disabled={saving}
                              onCheckedChange={(value) =>
                                updateOrderType(item.key, value)
                              }
                            />

                          </div>

                        </div>

                      </div>
                    );
                  })}

                </div>

              </div>  
          </TabsContent>

          {/* PAYMENTS */}
          <TabsContent value="payments">
              {/* PAYMENT TYPES */}
              <div className="bg-white rounded-3xl shadow-sm border border-slate-200 overflow-hidden">

                <div className="border-b border-slate-100 px-7 py-5">
                  <h2 className="text-2xl font-bold text-slate-800">
                    Payment Methods
                  </h2>

                  <p className="text-slate-500 mt-1">
                    Control which payment methods customers can use
                  </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5 p-7">

                  {paymentTypeList.map((item) => {

                    const checked =
                      restaurant?.payment_types?.[item.key] ?? true;

                    const saving =
                      savingKey === `payment_${item.key}`;

                    return (
                      <div
                        key={item.key}
                        className={`
                          border rounded-2xl p-5 transition-all
                          ${
                            checked
                              ? "border-blue-200 bg-blue-50"
                              : "border-slate-200 bg-slate-50"
                          }
                        `}
                      >

                        <div className="flex items-start justify-between">

                          <div>
                            <p className="font-semibold text-slate-800 text-lg">
                              {item.label}
                            </p>

                            <p className="text-sm mt-1 text-slate-500">
                              {checked ? "Enabled" : "Disabled"}
                            </p>
                          </div>

                          <div className="flex items-center gap-2">

                            {saving && (
                              <Loader2
                                size={16}
                                className="animate-spin text-slate-500"
                              />
                            )}

                            <Switch
                              checked={checked}
                              disabled={saving}
                              onCheckedChange={(value) =>
                                updatePaymentType(item.key, value)
                              }
                            />

                          </div>

                        </div>

                      </div>
                    );
                  })}

                </div>

              </div>
              {restaurant?.payment_types?.upi && (
              <div className="bg-white rounded-3xl shadow-sm border border-slate-200 overflow-hidden">

                <div className="border-b border-slate-100 px-7 py-5">
                  <h2 className="text-2xl font-bold text-slate-800">
                    Stripe Configuration
                  </h2>

                  <p className="text-slate-500 mt-1">
                    Configure Stripe payment gateway credentials
                  </p>
                </div>

                <div className="p-7">

                  <div className="grid grid-cols-1 gap-5">

                    <div>
                      <Label className="mb-2 block">
                        Publishable Key
                      </Label>

                      <input
                        value={stripeForm.publishable_key}
                        onChange={(e) =>
                          setStripeForm({
                            ...stripeForm,
                            publishable_key: e.target.value,
                          })
                        }
                        placeholder="pk_live_xxxxxxxxx"
                        className="w-full border rounded-xl px-4 py-3"
                      />
                    </div>

                    <div>
                      <Label className="mb-2 block">
                        Secret Key
                      </Label>

                      <input
                        type="password"
                        value={stripeForm.secret_key}
                        onChange={(e) =>
                          setStripeForm({
                            ...stripeForm,
                            secret_key: e.target.value,
                          })
                        }
                        placeholder="sk_live_xxxxxxxxx"
                        className="w-full border rounded-xl px-4 py-3"
                      />
                    </div>
                    <div>
                      <Label className="mb-2 block">
                        Webhook Secret
                      </Label>

                      <input
                        type="password"
                        value={stripeForm.webhook_secret}
                        onChange={(e) =>
                          setStripeForm({
                            ...stripeForm,
                            webhook_secret: e.target.value,
                          })
                        }
                        placeholder="whsec_xxxxxxxxx"
                        className="w-full border rounded-xl px-4 py-3"
                      />
                    </div>

                  </div>

                  <button
                    onClick={updateStripeConfiguration}
                    disabled={savingStripe}
                    className="mt-6 bg-black hover:bg-slate-800 text-white px-6 py-3 rounded-xl font-semibold"
                  >
                    {savingStripe
                      ? "Saving..."
                      : "Save Stripe Configuration"}
                  </button>

                </div>

              </div>
              )}
          </TabsContent>

          {/* DELIVERY */}
          <TabsContent value="delivery">
              {/* DELIVERY PROVIDER */}
              <div className="bg-white rounded-3xl shadow-sm border border-slate-200 overflow-hidden">

                <div className="border-b border-slate-100 px-7 py-5">
                  <h2 className="text-2xl font-bold text-slate-800">
                    Delivery Configuration
                  </h2>

                  <p className="text-slate-500 mt-1">
                    Select how delivery orders should be fulfilled
                  </p>
                </div>

                <div className="p-7">

                  <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">

                    {/* NO DELIVERY */}
                    <div
                      onClick={() =>
                        updateDeliveryProvider("none")
                      }
                      className={`
                        border rounded-3xl p-6 cursor-pointer transition-all
                        ${
                          restaurant?.delivery_provider === "none"
                            ? "border-slate-500 bg-slate-100 ring-2 ring-slate-300"
                            : "border-slate-200 hover:border-slate-400 bg-white"
                        }
                      `}
                    >

                      <div className="flex items-start justify-between">

                        <div className="flex gap-4">

                          <div className="bg-slate-200 p-4 rounded-2xl">
                            <Truck
                              className="text-slate-600"
                              size={24}
                            />
                          </div>

                          <div>
                            <h3 className="text-xl font-bold text-slate-800">
                              No Delivery
                            </h3>

                            <p className="text-slate-500 mt-2 text-sm leading-6">
                              Customers can only place pickup or
                              dine-in orders. Delivery will be
                              disabled.
                            </p>
                          </div>

                        </div>

                        {restaurant?.delivery_provider ===
                          "none" && (
                          <div className="bg-slate-700 text-white text-xs px-3 py-1 rounded-full font-semibold">
                            Active
                          </div>
                        )}

                      </div>

                    </div>

                    {/* INTERNAL */}
                    <div
                      onClick={() =>
                        updateDeliveryProvider("internal")
                      }
                      className={`
                        border rounded-3xl p-6 cursor-pointer transition-all
                        ${
                          restaurant?.delivery_provider ===
                          "internal"
                            ? "border-orange-500 bg-orange-50 ring-2 ring-orange-200"
                            : "border-slate-200 hover:border-orange-300 bg-white"
                        }
                      `}
                    >

                      <div className="flex items-start justify-between">

                        <div className="flex gap-4">

                          <div className="bg-orange-100 p-4 rounded-2xl">
                            <Truck
                              className="text-orange-600"
                              size={24}
                            />
                          </div>

                          <div>
                            <h3 className="text-xl font-bold text-slate-800">
                              Internal Delivery
                            </h3>

                            <p className="text-slate-500 mt-2 text-sm leading-6">
                              Use your own riders or delivery
                              staff for customer orders.
                            </p>
                          </div>

                        </div>

                        {restaurant?.delivery_provider ===
                          "internal" && (
                          <div className="bg-orange-500 text-white text-xs px-3 py-1 rounded-full font-semibold">
                            Active
                          </div>
                        )}

                      </div>

                    </div>

                    {/* UBER */}
                    <div
                      onClick={() =>
                        updateDeliveryProvider("uber")
                      }
                      className={`
                        border rounded-3xl p-6 cursor-pointer transition-all
                        ${
                          restaurant?.delivery_provider ===
                          "uber"
                            ? "border-black bg-slate-50 ring-2 ring-slate-300"
                            : "border-slate-200 hover:border-slate-400 bg-white"
                        }
                      `}
                    >

                      <div className="flex items-start justify-between">

                        <div className="flex gap-4">

                          <div className="bg-black p-4 rounded-2xl">
                            <Truck
                              className="text-white"
                              size={24}
                            />
                          </div>

                          <div>
                            <h3 className="text-xl font-bold text-slate-800">
                              Uber Direct
                            </h3>

                            <p className="text-slate-500 mt-2 text-sm leading-6">
                              Automatically assign Uber delivery
                              partners for online orders.
                            </p>
                          </div>

                        </div>

                        {restaurant?.delivery_provider ===
                          "uber" && (
                          <div className="bg-black text-white text-xs px-3 py-1 rounded-full font-semibold">
                            Active
                          </div>
                        )}

                      </div>

                    </div>

                  </div>

                  {savingDeliveryProvider && (
                    <div className="flex items-center gap-3 mt-5 text-slate-500">
                      <Loader2
                        size={18}
                        className="animate-spin"
                      />

                      Updating delivery provider...
                    </div>
                  )}

                </div>

              </div>  
          </TabsContent>
        </Tabs>
        )}
      </div>
    </div>
  </AdminLayout>
);
}